import { makeStyles } from 'tss-react/mui';
import { Add } from '@mui/icons-material';
import { Button, EditableSectionRow, EditableSectionRowList, EditableSectionRowListProps, EditableSectionRowProps, useEditableSectionsContext } from '@uplift/ui-v2';
import { useDisplayInvalidRows } from '../profile.utils';
import { MatchingProfileRow } from '@uplift/types';
import { RequiredText } from './RequiredText.component';

export type RequiredProfileEditableSectionRowProps = EditableSectionRowProps & {
  rowKey: MatchingProfileRow;
};

export const RequiredProfileEditableSectionRow: React.VFC<RequiredProfileEditableSectionRowProps> = props => {
  const invalidRows = useDisplayInvalidRows();
  const { classes, cx } = useRequiredProfileEditableSectionRowStyles();
  const { editKey } = useEditableSectionsContext();

  const isInvalid = invalidRows.includes(props.rowKey);

  if (isInvalid && props.kind === 'editable-row') {
    const isEditing = editKey === props.rowKey;

    return (
      <EditableSectionRow
        {...props}
        className={cx(props.className, !isEditing && classes.bgWarningBackground)}
        mobileClassName={cx(props.mobileClassName, !isEditing && classes.bgWarningBackground)}
        editButton={(
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Add />}
          >
            Add
          </Button>
        )}
        mobileEditButton={(
          <Button
            variant="contained"
            color="secondary"
          >
            Add
          </Button>
        )}
      >
        <RequiredText>
          Required before profile can be submitted
        </RequiredText>
      </EditableSectionRow>
    );
  }

  return <EditableSectionRow {...props} />;
};

const useRequiredProfileEditableSectionRowStyles = makeStyles({ name: 'RequiredProfileEditableSectionRow' })(theme => ({
  bgWarningBackground: {
    backgroundColor: theme.palette.warning.background,
  },
}));

export type RequiredProfileEditableSectionRowListProps = EditableSectionRowListProps & {
  rowKey: MatchingProfileRow;
};

export const RequiredProfileEditableSectionRowList: React.VFC<RequiredProfileEditableSectionRowListProps> = props => {
  const invalidRows = useDisplayInvalidRows();
  const { editKey } = useEditableSectionsContext();

  const isInvalid = invalidRows.includes(props.rowKey);
  const isEditing = editKey === props.rowKey;

  if (isInvalid && !isEditing) {
    return (
      <RequiredProfileEditableSectionRow
        rowKey={props.rowKey}
        kind="editable-row"
        form={null}
        label={props.label}
      />
    );
  }

  return <EditableSectionRowList {...props} />;
};
